import Kfit from 'integrations/Kfit';

export const refundRealTimeRetailPaymentsPlatformTransaction = (id, params) =>
  Kfit.post(`/v1/rpp_credit_transfers/${id}/refund`, params);
